const DEFAULT_INCLUDES = [
    'cart.lineItems.physicalItems.options',
    'cart.lineItems.digitalItems.options',
    'customer',
    'payments',
    'promotions.banners',
];

export default DEFAULT_INCLUDES;
